import apiAuth from "@/services/http/apiAuth";

/**
 * Servicio de subida de archivos.
 * Usa el cliente autenticado (apiAuth) que ya agrega el Bearer token.
 */

/**
 * Sube UNA imagen para una noticia.
 * @param {File} file - archivo a subir
 * @param {object} opts - { newsId?: number, isCover?: boolean }
 * @returns {Promise<{ url, fileId, newsImageId }>}
 */
export async function subirImagenNoticia(
  file,
  { newsId = null, isCover = false } = {},
) {
  const formData = new FormData();
  formData.append("file", file);
  if (newsId) formData.append("news_id", String(newsId));
  if (isCover) formData.append("is_cover", "true");

  const res = await apiAuth.post("/files/news-upload", formData);
  return res.data;
}

/**
 * Sube VARIAS imágenes en una sola request.
 * @param {FileList|File[]} files
 * @param {object} opts - { newsId?: number }
 * @returns {Promise<{ items: Array<{ url, fileId, newsImageId, originalName }> }>}
 */
export async function subirImagenesNoticia(files, { newsId = null } = {}) {
  const formData = new FormData();
  const arr = Array.from(files);
  arr.forEach((f) => formData.append("files", f));
  if (newsId) formData.append("news_id", String(newsId));

  const res = await apiAuth.post("/files/news-upload-multiple", formData);
  return res.data;
}

/**
 * Borra un archivo del backend (S3 + Files + news_image).
 * @param {object} opts - { fileUrl: string, newsImageId?: number }
 */
export async function eliminarArchivo({ fileUrl, newsImageId = null }) {
  const res = await apiAuth.delete("/files/delete-file", {
    data: { fileUrl, newsImageId },
  });
  return res.data;
}

export async function subirDocumentoFederacion(file, { title = "" } = {}) {
  const formData = new FormData();
  formData.append("file", file);
  if (title) formData.append("title", title);

  const res = await apiAuth.post("/files/federation-document", formData);
  return res.data;
}
